import app from 'flarum/forum/app';
import DialogList from './components/DialogList';
/**
 * A Deck column of the member's conversations. It shares `app.dialogs` with
 * the messages page, so reading a conversation in one updates the other, and
 * with Realtime on, extendRealtime() already refreshes it as messages arrive.
 */
export default class DialogsDeckSource {
  /** The newest `lastMessageAt` on screen. */
  key = null;
  load() {
    return (app.dialogs.hasItems() ? Promise.resolve() : app.dialogs.refresh()).then(() => this.snapshot());
  }
  view() {
    return m(DialogList, {
      state: app.dialogs,
      itemActions: true
    });
  }
  async checkForNew() {
    return (await this.newer()).length;
  }
  async applyNew() {
    const count = (await this.newer()).length;
    if (count) await app.dialogs.revalidate();
    this.snapshot();
    return count;
  }

  /** extendRealtime() already moves the dialog to the top of `app.dialogs`, which this shares. */
  onRealtime(event) {
    return event.name === 'Flarum\\Messages\\DialogMessage\\Event\\Created' ? 'updated' : undefined;
  }
  showNew() {
    return app.dialogs.revalidate().then(() => this.snapshot());
  }

  /** Conversations with a message since the key, other than the member's own. */
  async newer() {
    const latest = await app.store.find('dialogs', {
      sort: '-lastMessageAt',
      include: 'lastMessage,lastMessage.user',
      page: {
        limit: 5,
        total: 0
      }
    });
    return latest.filter(dialog => {
      const at = dialog.lastMessageAt();
      const lastMessage = dialog.lastMessage();
      return at && (!this.key || at > this.key) && !(lastMessage && lastMessage.user() === app.session.user);
    });
  }
  snapshot() {
    this.key = null;
    app.dialogs.getAllItems().forEach(dialog => {
      const at = dialog.lastMessageAt();
      if (at && (!this.key || at > this.key)) this.key = at;
    });
  }
}